import { NotificationConfiguration } from '../notification.templates';

export const GUEST_FINALIZE_MEETING_TEMPLATE: NotificationConfiguration = {
  inapp: `<b>{triggeredByName}</b> shared the minutes for the agenda item <b>{title}</b> with you.`,
  email: {
    ctaKey: 'go_to_agenda_item',
  },
};
